import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import { Comment } from "@/gql"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useUtilities } from "@/hooks/useUtilities"
import Previewable from "@/components/layout/Previewable.vue"
import moment from "moment"


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatComment',
  props: {
    withReply: { type: Boolean },
    comment: null
  },
  setup(__props: any) {


const { truncate, getPreviewableType } = useUtilities()

const showPreviewable = ref(false)

function formatDate(timestamp: string, timeFormat = "h:mm A") {
  const date = moment(timestamp)

  if (date.isSame(moment(), "day")) {
    return date.format(timeFormat)
  } else if (date.isSame(moment().subtract(1, "days"), "day")) {
    return `Yesterday at ${date.format(timeFormat)}`
  } else {
    return date.format(`MMMM Do [at] ${timeFormat}`)
  }
}

return { __sfc: true,truncate, getPreviewableType, showPreviewable, formatDate, UserAvatar, Icon, Previewable }
}

})